import {EnvironmentConfig} from './environment.config';

export const environment = {
  live: true,
  environmentName: 'Development',
  baseUrl: 'http://dev.greydom.com:8082/api',
  baseWeUrl: 'http://dev.greydom.com:8088/api',
  baseClmUrl: 'http://dev.greydom.com:8086/api',
  baseItsUrl: 'http://dev.greydom.com:8087/api',
  baseIgnUrl: 'http://dev.greydom.com:8089/api',
  baseEngineUrl: 'https://app-dev.ruleslab.com',
  baseAuthorUrl: 'https://app-dev.ruleslab.com',
  baseReportingUrl: 'http://dev.greydom.com:8083/jasperserver',
  serviceDeskRequestsUrl: 'https://greydom.atlassian.net/servicedesk/customer/user/requests?page=1',
  reportingCredentials: 'j_username=endpoint_user_internal&j_password=fjeH5HdMqmh*4eJ9',
  contextRoute: '',
  portalRoute: EnvironmentConfig.portalRoute.normal,
  keycloak: {
    url: 'http://dev.greydom.com:8081/auth/',
    realm: 'greydom',
    clientId: 'greydom-angular-develop',
    redirectOverrideUrlEnterprise: '',
    redirectOverrideUrlProvider: '',
    redirectOverrideUrlOnboarding: '',
    redirectOverrideUrlBroker: ''
  },
  submitAuthToIgn: false,
  submitClaimToIgn: false,
  allowNormalPortalAccess: true,
  allowProviderPortalAccess: true,
  allowSubmitClaimForProviderPortal: true,
  allowSubmitAuthForProviderPortal: true,
  allowSubmitClaimForNormalPortal: true,
  allowSubmitAuthForNormalPortal: true,
  allowGeneralPractitionerDrugsOnly: false,
  allowGovernmentData: true,
  allowHealthCloudScore: true,
  allowBrokerPortalAccess: true,
  claimManagementFeatures: {
    cases: true,
    payments: true
  },
  defaultPracticeNumber: '',
  primarySubClass: 'None',
  requireCaseToCaptureTransaction: true,
  defaultProviderLabel: 'Provider Name',
  timeZone: 'UTC',
  encounterOverrideIndicators: {
    overrideIndicator1: 'Network Override',
  },
  activityOverrideIndicators: {
    overrideIndicator1: 'Out Of Formulary Override',
    overrideIndicator2: 'Early Refill Override',
    overrideIndicator3: 'Extended Supply Override',
    overrideIndicator4: 'Pay As Claimed Override',
    manualCopaymentOverride: 'Manual Copayment Override',
  },
  jiraWidget: {
    showWidget: true,
    dataKey: EnvironmentConfig.jiraWidgetKeys.Greydom
  },
  jiraApi: {
    enabled: true,
    baseUrl: 'https://greydom.atlassian.net',
    serviceDeskId: '36',
    keyPrefix: 'TSM'
  },
  theme: EnvironmentConfig.themes.Greydom,
  favicon: EnvironmentConfig.favicon.Greydom,
  showPoweredByOverride: false,
  vatPercentage: EnvironmentConfig.vatPercentage,
  externalClientUrl: EnvironmentConfig.externalClientUrl.Empty,
  acceptedApplicationLookBackDays: EnvironmentConfig.acceptedApplicationLookBackDays,
  applicationCapture: EnvironmentConfig.applicationCapture,
  schema: EnvironmentConfig.schema
};
